import { render, staticRenderFns } from "./table10.vue?vue&type=template&id=72bf8501&scoped=true&"
import script from "./table10.vue?vue&type=script&lang=js&"
export * from "./table10.vue?vue&type=script&lang=js&"
import style0 from "./table10.vue?vue&type=style&index=0&id=72bf8501&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72bf8501",
  null
  
)

export default component.exports